// Mood Board Color
export const BG_PRIMARY = 'rgba(132,61,61,1)';
export const BG_SECONDARY = 'rgba(229,221,221,1)';
export const BG_ALTERNATIVE = 'rgba(132,61,61,1)';

export const ASSETS_PRIMARY = '#ffebca';
export const BG_LAYER = 'rgba(59,2,10,1)';

// Text Color
export const TEXT_PRIMARY = 'rgba(255,255,255,1)'; //brown dark
export const TEXT_SECONDARY = 'rgba(232,166,114,1)'; // Title color section
export const TEXT_ALTERNATIVE = 'rgba(104,49,72,1)';

// Music & Navigation Color
export const NAVIGATION_COLOR = 'rgba(217, 134, 70, 1)'; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya

// Default Button Color
export const BUTTON_PROPS = {
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
